firebird.factory('annotationConnection', [
    '$window',
    '$timeout',
    'helperService',
    'logService',
    function ($window, $timeout, helperService, logService) {
        var annotationConnection = function (opts) {
            var self = this;

            const logger = logService.createLoggerWithSource('annotationConnection');

            self.initiatorAttendantId = opts.initiatorAttendantId;
            self.viewerAttendantId = opts.viewerAttendantId;
            self.viewerName = opts.viewerName;
            self.initiator = opts.initiator;
            self.callbacks = opts.callbacks;
            self.iceServers = opts.iceServers;
            self.inActiveConnection = false;

            self.viewerSendChannel = null;
            self.initiatorReceiveChannel = null;

            self.peerConnection = null;
            self.penColor = 'black';

            var close = function () {
                if (self.peerConnection) {
                    self.peerConnection.close();
                    self.peerConnection = null;
                    self.inActiveConnection = false;
                }
            };

            var getViewerAttendantId = function () {
                return self.viewerAttendantId;
            };

            var getInitiatorAttendantId = function () {
                return self.initiatorAttendantId;
            };

            var connectCreateOffer = function () {
                logger.log('connectCreateOffer ... ');

                self.peerConnection = _getRTCPeerConnection({ iceServers: self.iceServers });

                self.initiatorReceiveChannel = self.peerConnection.createDataChannel('annotation-channel');
                self.initiatorReceiveChannel.onmessage = _dataChannelMessage;
                self.initiatorReceiveChannel.onopen = _dataChannelStatusChange;
                self.initiatorReceiveChannel.onclose = _dataChannelStatusChange;
                self.peerConnection.onicecandidate = _onNewLocalIceCandidate;
                self.peerConnection.oniceconnectionstatechange = _onICEConnectionStateChange;

                self.peerConnection
                    .createOffer()
                    .then(function (offer) {
                        self.peerConnection.setLocalDescription(offer);
                        self.callbacks.processOffer(offer, self.viewerAttendantId);
                    })
                    .catch(function (err) {
                        logger.error('connectCreateOffer', 'Error when create offer', err);
                    });
            };

            var connectCreateAnswer = function (data) {
                logger.log('connectCreateAnswer ... ');

                //TODO: add in exchange token
                /* if(data.exchangeToken){
                logger.log('exchangeToken found');
                receiverExchangeToken = data.exchangeToken;
            } */
                self.peerConnection = _getRTCPeerConnection({ iceServers: self.iceServers });

                self.peerConnection.onicecandidate = _onNewLocalIceCandidate;
                self.peerConnection.oniceconnectionstatechange = _onICEConnectionStateChange;
                self.peerConnection.ondatachannel = _onDataChannelCallbackViewer;

                self.peerConnection
                    .setRemoteDescription({
                        type: data.offer.type,
                        sdp: data.offer.sdp
                    })
                    .then(function () {
                        logger.log('setRemoteDescription succeeded');
                        self.peerConnection.createAnswer().then(function (answer) {
                            self.peerConnection.setLocalDescription(answer);
                            self.callbacks.processAnswer(answer, self.initiatorAttendantId);
                        });
                    })
                    .catch(function (error) {
                        logger.log('setRemoteDescription failed with error:', error);
                    });
            };

            var connectReceiveAnswer = function (answer) {
                logger.log('connectReceiveAnswer ... ');

                self.peerConnection.setRemoteDescription({
                    type: answer.type,
                    sdp: answer.sdp
                });
            };

            var sendDataChannelMessage = function (msg) {
                if (self.viewerSendChannel) {
                    try {
                        self.viewerSendChannel.send(JSON.stringify(msg));
                    } catch (e) {
                        logger.log('annotation connection sendDataChannelMessage: ', e);
                    }
                }
                //add initiator received channel
            };

            var connectICECandiate = function (candidate) {
                logger.log('connectICECandiate ... ', candidate);
                if (candidate?.candidate_) {
                    candidate.candidate = candidate.candidate_;
                    candidate.sdpMid = candidate.sdpMid_;
                    candidate.sdpMLineIndex = candidate.sdpMLineIndex_;
                }
                self.peerConnection.addIceCandidate(candidate);
            };

            var _getRTCPeerConnection = function (servers) {
                var vdiRef = helperService.getVDIRef && helperService.getVDIRef();
                if (vdiRef && vdiRef.useNativePeerConnectionForAnnotation && vdiRef.toNativePeerConnectionConfig) {
                    servers = vdiRef.toNativePeerConnectionConfig(servers);
                }
                return new $window.RTCPeerConnection(servers);
            };

            var _onNewLocalIceCandidate = function (ev) {
                logger.log('_onNewLocalIceCandidate ... ', self.initiatorAttendantId, self.viewerAttendantId);
                var toAttendantId = self.initiatorAttendantId ? self.initiatorAttendantId : self.viewerAttendantId;
                self.callbacks.processICECandidate(ev, toAttendantId);
            };

            var _onDataChannelCallbackViewer = function (evt) {
                logger.log('_onDataChannelCallbackViewer ... ');
                self.viewerSendChannel = evt.channel;
                self.viewerSendChannel.onopen = _dataChannelOpen;
                self.viewerSendChannel.onclose = _dataChannelClose;
            };

            var _dataChannelMessage = function (ev) {
                self.callbacks.dataChannelMessage(ev);
            };

            var _onICEConnectionStateChange = function (ev) {
                logger.log('_onICEConnectionStateChange ... ');

                if (self.peerConnection && self.peerConnection.iceConnectionState) {
                    logger.log(
                        'annotationConnection iceConnectionState changed to:',
                        self.peerConnection.iceConnectionState
                    );
                }

                if (self.inActiveConnection && self.peerConnection) {
                    if (self.peerConnection.iceConnectionState === 'disconnected') {
                        logger.log('annotationConnection disconnected ice connection state ... calling stopSession');
                        self.inActiveConnection = false;
                        if (self.viewerAttendantId) {
                            self.callbacks.disconnected({ viewerId: self.viewerAttendantId });
                        } else {
                            self.callbacks.disconnected();
                        }
                        //TODO: do call back
                        return;
                    }
                }

                if (self.inActiveConnection === false && self.peerConnection) {
                    if (
                        self.peerConnection.iceConnectionState === 'connected' ||
                        self.peerConnection.iceConnectionState === 'completed'
                    ) {
                        logger.log('ICE Complete for annotation');
                        self.inActiveConnection = true;
                        if (self.viewerAttendantId) {
                            var msg = {
                                viewerAttendantId: self.viewerAttendantId,
                                viewerName: self.viewerName,
                                penColor: self.penColor
                            };
                            self.callbacks.ready(msg);
                        } else {
                            self.callbacks.ready();
                        }
                    }
                }
            };

            var _dataChannelStatusChange = function (status) {
                var appendMsg = self.initiatorAttendantId ? ' for initiator ' : ' for viewer ';

                if (status.readyState === 'open') {
                    logger.log('dataChannelStatusChange: status open' + appendMsg);
                } else {
                    logger.log('dataChannelStatusChange: status not open' + appendMsg, status);
                }
            };

            var _dataChannelOpen = function () {
                logger.log('dataChannelOpen ...');
            };

            var _dataChannelClose = function () {
                logger.log('dataChannelClose ...');
                self.callbacks.dataChannelClose();
            };

            var setPenColor = function (color) {
                self.penColor = color;
            };

            var getIsInActiveConnection = function () {
                return self.inActiveConnection;
            };

            var getRawPeerConnection = function () {
                return self.peerConnection;
            };

            return {
                close: close,
                getViewerAttendantId: getViewerAttendantId,
                getInitiatorAttendantId: getInitiatorAttendantId,
                connectReceiveAnswer: connectReceiveAnswer,
                connectICECandiate: connectICECandiate,
                connectCreateOffer: connectCreateOffer,
                connectCreateAnswer: connectCreateAnswer,
                sendDataChannelMessage: sendDataChannelMessage,
                setPenColor: setPenColor,
                getIsInActiveConnection: getIsInActiveConnection,
                getRawPeerConnection: getRawPeerConnection
            };
        };
        return annotationConnection;
    }
]);
